<template>
    <div class="row p-4">
        <div class="col-12">
            <h2 v-if="enableMultipleJourneyTypeFilter" class="d-inline-block">Refine results</h2>
            <h2 v-else class="d-inline-block">Refine</h2>
            <a href="javascript:void(0)" v-b-toggle.sidebar-filter class="modal-close-text float-right c-pointer">Close</a>
        </div>
        <div class="row ">
            <div class="col-12 mb-3">
                <div v-if="enableMultipleJourneyTypeFilter">
                    <hr />
                    <p class="px-2" for="sortingInputGroup">Showing</p>
                    <hr />
                    <div class="form-check ml-3 mt-2" v-for="(option, index) in resultFilters" :key="index">
                        <input class="form-check-input scale-1-5" @change="handleMultipleFilterChange({e: $event, stage: option.stage})" :checked="option.selected" type="checkbox" value :id="option.stage" />
                        <label class="form-check-label ml-2" :for="option.name">
                            <span class="ml-1" :class="{
                                'disabled': !availableJourneyStages.includes(option.stage)
                            }">{{ option.name }}</span>
                        </label>
                    </div>
                </div>
                <div v-else class="input-group d-flex">
                    <div class="input-group-prepend">
                        <label class="input-group-text bg-white filter-box" for="sortingInputGroup">Showing</label>
                    </div>
                    <select class="d-inline-block flex-grow-1" v-model="resultFilter.selected" id="result-filter">
                        <option v-for="(option, index) in resultFilters" :key="index" :value="option.stage">
                            <span>{{ option.name }}</span>
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="py-3">
                    <span>Inactive transport methods are unavailble for this journey</span>
                </div>
                <hr />
                <div class="input-group d-flex">
                    <div class="input-group-prepend">
                        <label class="input-group-text bg-white filter-box" for="sortingInputGroup">Sort by</label>
                    </div>
                    <hr />
                    <select class="d-inline-block flex-grow-1 refine-select" v-model="resultSort.selected" id="sort-filter">
                        <option v-for="(option, index) in sortOptions" :key="index" :value="option.sort">
                            <span class="ml-1">{{ option.label }}</span>
                        </option>
                    </select>
                </div>
                <hr />
            </div>
        </div>
    </div>
</template>
<script>

import {
    mapState,
    mapGetters,
    mapMutations,
} from 'vuex'

import { sortOptions } from '@/store/options'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND];

export default {
    name: 'refine',
    data() {
        return {
            sortOptions,
            enableMultipleJourneyTypeFilter: whitelabel.enableMultipleJourneyTypeFilter,
        }
    },

    computed: {
        ...mapState([
            'resultFilter',
            'resultSort',
        ]),
        ...mapGetters([
            'resultFilters',
            'availableJourneyStages',
        ]),
    },
    methods: {
        ...mapMutations([
            'handleMultipleFilterChange',
        ]),
    },
}
</script>
